import { render } from "./ProductAttributes.vue?vue&type=template&id=89a3b0ba&scoped=true"
import script from "./ProductAttributes.vue?vue&type=script&lang=js"
export * from "./ProductAttributes.vue?vue&type=script&lang=js"

import "./ProductAttributes.vue?vue&type=style&index=0&id=89a3b0ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89a3b0ba"]])

export default __exports__